let lastScroll = 0;

window.addEventListener('scroll', () => {
  // Only apply on mobile width
  if (window.innerWidth >= 750) return;

  const currentScroll = window.pageYOffset;
  const scrollingUp = currentScroll < lastScroll;

  const catefilter = document.querySelector('.cate-page .cate-content .cate-sidebar');
  const filterRow = document.querySelector('.cate-filter-row');

  if (!catefilter || !filterRow) return;

  if (scrollingUp) {
    catefilter.classList.add('catefilter-sticky-up');
    filterRow.classList.add('filterRow-sticky-up');
  } else {
    catefilter.classList.remove('catefilter-sticky-up');
    filterRow.classList.remove('filterRow-sticky-up');
  }

  lastScroll = currentScroll;
});
